"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Telegraph Public API
 * Public API offering access to Telegraph data
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: bookingsupport@telegraph.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateAndChargesL1ToJSON = exports.RateAndChargesL1FromJSONTyped = exports.RateAndChargesL1FromJSON = exports.instanceOfRateAndChargesL1 = void 0;
/**
 * Check if a given object implements the RateAndChargesL1 interface.
 */
function instanceOfRateAndChargesL1(value) {
    return true;
}
exports.instanceOfRateAndChargesL1 = instanceOfRateAndChargesL1;
function RateAndChargesL1FromJSON(json) {
    return RateAndChargesL1FromJSONTyped(json, false);
}
exports.RateAndChargesL1FromJSON = RateAndChargesL1FromJSON;
function RateAndChargesL1FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lading_line_item_number_01': json['lading_line_item_number_01'] == null ? undefined : json['lading_line_item_number_01'],
        'freight_rate_02': json['freight_rate_02'] == null ? undefined : json['freight_rate_02'],
        'rate_value_qualifier_03': json['rate_value_qualifier_03'] == null ? undefined : json['rate_value_qualifier_03'],
        'amount_charged_04': json['amount_charged_04'] == null ? undefined : json['amount_charged_04'],
        'advances_05': json['advances_05'] == null ? undefined : json['advances_05'],
        'prepaid_amount_06': json['prepaid_amount_06'] == null ? undefined : json['prepaid_amount_06'],
        'rate_combination_point_code_07': json['rate_combination_point_code_07'] == null ? undefined : json['rate_combination_point_code_07'],
        'special_charge_or_allowance_code_08': json['special_charge_or_allowance_code_08'] == null ? undefined : json['special_charge_or_allowance_code_08'],
        'rate_class_code_09': json['rate_class_code_09'] == null ? undefined : json['rate_class_code_09'],
        'entitlement_code_10': json['entitlement_code_10'] == null ? undefined : json['entitlement_code_10'],
        'charge_method_of_payment_code_11': json['charge_method_of_payment_code_11'] == null ? undefined : json['charge_method_of_payment_code_11'],
        'special_charge_description_12': json['special_charge_description_12'] == null ? undefined : json['special_charge_description_12'],
        'tariff_application_code_13': json['tariff_application_code_13'] == null ? undefined : json['tariff_application_code_13'],
        'declared_value_14': json['declared_value_14'] == null ? undefined : json['declared_value_14'],
        'rate_value_qualifier_15': json['rate_value_qualifier_15'] == null ? undefined : json['rate_value_qualifier_15'],
        'lading_liability_code_16': json['lading_liability_code_16'] == null ? undefined : json['lading_liability_code_16'],
        'billed_rated_as_quantity_17': json['billed_rated_as_quantity_17'] == null ? undefined : json['billed_rated_as_quantity_17'],
        'billed_rated_as_qualifier_18': json['billed_rated_as_qualifier_18'] == null ? undefined : json['billed_rated_as_qualifier_18'],
        'percentage_as_decimal_19': json['percentage_as_decimal_19'] == null ? undefined : json['percentage_as_decimal_19'],
        'currency_code_20': json['currency_code_20'] == null ? undefined : json['currency_code_20'],
        'amount_21': json['amount_21'] == null ? undefined : json['amount_21'],
        'lading_value_22': json['lading_value_22'] == null ? undefined : json['lading_value_22'],
    };
}
exports.RateAndChargesL1FromJSONTyped = RateAndChargesL1FromJSONTyped;
function RateAndChargesL1ToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'lading_line_item_number_01': value['lading_line_item_number_01'],
        'freight_rate_02': value['freight_rate_02'],
        'rate_value_qualifier_03': value['rate_value_qualifier_03'],
        'amount_charged_04': value['amount_charged_04'],
        'advances_05': value['advances_05'],
        'prepaid_amount_06': value['prepaid_amount_06'],
        'rate_combination_point_code_07': value['rate_combination_point_code_07'],
        'special_charge_or_allowance_code_08': value['special_charge_or_allowance_code_08'],
        'rate_class_code_09': value['rate_class_code_09'],
        'entitlement_code_10': value['entitlement_code_10'],
        'charge_method_of_payment_code_11': value['charge_method_of_payment_code_11'],
        'special_charge_description_12': value['special_charge_description_12'],
        'tariff_application_code_13': value['tariff_application_code_13'],
        'declared_value_14': value['declared_value_14'],
        'rate_value_qualifier_15': value['rate_value_qualifier_15'],
        'lading_liability_code_16': value['lading_liability_code_16'],
        'billed_rated_as_quantity_17': value['billed_rated_as_quantity_17'],
        'billed_rated_as_qualifier_18': value['billed_rated_as_qualifier_18'],
        'percentage_as_decimal_19': value['percentage_as_decimal_19'],
        'currency_code_20': value['currency_code_20'],
        'amount_21': value['amount_21'],
        'lading_value_22': value['lading_value_22'],
    };
}
exports.RateAndChargesL1ToJSON = RateAndChargesL1ToJSON;
